import { createStore } from 'vuex'

import utils from  '../utils.js'

export default createStore({
  state: {
    user: false,

    all_users: [],

    implant_brands: [],
    implant_models: [],
    operation_types: [],
    revision_types: [],
    subscription_enabled_cities: [],

    pages: {
      calendar: {
        lastView: false
      },
      client: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      place: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      implant: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      operation: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      call: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      draft: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      deadline: {
        number: 1,
        size: 30,
        scroll: 0
      },
      order: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      },
      product: {
        form: false,
        number: 1,
        size: 30,
        scroll: 0
      }
    },
    
    filters: {
      client: {},
      operationTable: {
        range: {start: utils.getBefore30Day(), end: utils.getAfter30Day()}
      },
      operationMap: {
        operationRange: {start: utils.getFirstDayOfWeek(), end: utils.getLastDayOfWeek()},
        callRange: {start: utils.getFirstDayOfWeek(), end: utils.getLastDayOfWeek()},
        expireRange: {start: utils.getFirstDayOfMonth(), end: utils.getLastDayOfMonth()}
      },
      operationCalendar: {
        
      },
      place: {

      },
      implant: {
        archived: null,
        dismissed: null
      },
      revision: {
        range: {start: new Date().getFirstDayMonth(), end: new Date().getLastDayMonth()}
      },
      deadline: {
        range: {start: new Date().getFirstDayMonth(), end: new Date().getLastDayMonth()}
      },
      call: {
        range: null,
        archived: {'label': 'No', value: false}
      },
      draft: {
      },
      order: {
        range: null,
        archived: {'label': 'No', value: false}
      },
      product: {
        archived: {'label': 'No', value: false}
      }
    }
  },
  getters: {
    amAdmin(state) {
      return state.user && state.user.isAdmin
    },

    amOperator(state, getters) {
      return state.user && getters.operators.find(operator => operator._id === state.user._id)
    },

    operators(state) {
      return state.all_users.filter(user => user.isOperator && !user.deleted ).sort((a, b) => {
        if (a.surname === b.surname) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        }
        return a.surname.toLowerCase().localeCompare(b.surname.toLowerCase())
      })
    },

    operatorsFilter(state) {
      return state.all_users.filter(user => user.isOperator ).sort((a, b) => {
        if (a.deleted && !b.deleted) {
          return 1
        } else if (!a.deleted && b.deleted) {
          return -1
        }
        if (a.surname === b.surname) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        }
        return a.surname.toLowerCase().localeCompare(b.surname.toLowerCase())
      })
    },

    users(state) {
      return state.all_users.filter(user => !user.deleted)
    },

    modelFiles: (state) => (name) => {
      const found = state.implant_models.find(model => model.name === name)
      if (found && found.files) {
        return found.files
      } else {
        return []
      }
    },

    getForm: (state) => (name) => {
      return state.pages[name].form
    }
  },
  mutations: {
    setUser(state, value) {
      state.user = value
    },
    setFilter(state, payload) {
      state.filters[payload.name] = payload.value
    },
    setAllUsers(state, value) {
      state.all_users = value
    },
    setSettings(state, value) {
      value.forEach(setting => {
        if (setting.name === 'implant_brands') {
          state.implant_brands = setting.value.sort((a, b) => a.name.localeCompare(b.name))
        } else if (setting.name === 'implant_models') {
          state.implant_models = setting.value.sort((a, b) => a.name.localeCompare(b.name))
        } else if (setting.name === 'operation_types') {
          state.operation_types = setting.value.sort((a, b) => a.name.localeCompare(b.name))
        } else if (setting.name === 'revision_types') {
          state.revision_types = setting.value.sort((a, b) => a.name.localeCompare(b.name))
        } else if (setting.name === 'subscription_enabled_cities') {
          state.subscription_enabled_cities = setting.value.sort((a, b) => a.name.localeCompare(b.name))
        }
      })
    },

    setForm(state, payload) {
      state.pages[payload.name].form = payload.value
    },

    setPage(state, payload) {
      state.pages[payload.name] = payload.value
    }
  },
  actions: {
  },
  modules: {
  }
})